/**
 * Every write carries an idempotency key generated once per user intent, so a
 * repeated click or a retry after a lost answer is never done twice (ADR-0016 §2.1).
 */
export function newIdempotencyKey(): string {
  return globalThis.crypto.randomUUID();
}

/**
 * One user intent: the same key until `reset()`, which a screen calls when
 * the person changes what they are asking for (or once it has succeeded).
 */
export function createIntent(newKey: () => string = newIdempotencyKey) {
  let key: string | null = null;
  return {
    key(): string {
      key ??= newKey();
      return key;
    },
    reset(): void {
      key = null;
    },
  };
}
